import { Button, Col, Popover, Row, theme } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { options } from "../../../../Helper/constant";
import {
  AccountOpeningViewCol,
  Accounts,
  AddButton,
  ContentDiv,
  ContentFooter,
} from "../style";
import ThemeTextLabel from "../../../../components/ThemeTextLabel";
import ThemeInputNumber, {
  converterFunction,
} from "../../../../components/ThemeInputNumber/ThemeInputNumber";

const AccountOpeningView = ({ is_edits, rent, parentForm }) => {
  const token = theme.useToken().token;
  //state
  const [accountOptions, setAccountOptions] = useState([]);
  const [newValue, setNewValue] = useState(0);
  const [showModal, setShowModal] = useState({
    flage: false,
    name: "",
    action: "",
  });

  //redux
  const accountType = useSelector(
    (state) => state.userAccountSlice?.accountType
  );
  const accountDetails = useSelector(
    (state) => state.userAccountSlice.accountDetails
  );
  const parentDetails = useSelector(
    (state) => state.authSlice.MarketAccessDetails?.accountDetails
  );
  const parentBasicInfo = useSelector(
    (state) => state.authSlice?.MarketAccessDetails?.basicInfo
  );
  const constantValue = useSelector(
    (state) => state.globleSlice?.constantValue
  );

  const isMaster = accountType === "masterAdmin";

  // life cycle
  useEffect(() => {
    if (accountType) {
      let array = [];
      let allow = false;
      let authorityLevel = 0;
      options.user.accountType.forEach((element) => {
        if (element?.value === accountType) {
          authorityLevel = element?.authorityLevel;
          allow = true;
          return;
        }
        // if (authorityLevel < element?.authorityLevel) {
        //   array.push(element);
        // }
        if (allow) {
          array.push(element);
        }
      });
      setAccountOptions(array);
    }
  }, [accountType]);

  const handleAdd = (value) => {
    let action = showModal?.action;
    let name = showModal?.name;

    parentForm.setFields([
      {
        name: `allowNoOfAccount${value}`,
        value:
          Number(parentForm.getFieldValue([`allowNoOfAccount${value}`]) || 0) +
          (action === "add" ? Number(newValue) : -Number(newValue)),
        touched: true,
      },
    ]);
    parentForm.validateFields([`allowNoOfAccount${value}`]);
    setShowModal({ flage: false, name: "", action: "" });
    setNewValue(0);
  };
  const handleOnChange = (e) => {
    setNewValue(e.target.value);
  };
  const handleCancel = () => {
    setShowModal({ flage: false, name: "", action: "" });
    setNewValue(0);
  };
  const showPopover = (name, value) => {
    setShowModal({ flage: true, name: name, action: value });
  };

  const content = (value) => {
    return (
      <ContentDiv>
        <ThemeInputNumber
          inputProps={{
            onChange: handleOnChange,
          }}
          extraProps={{
            input_type: "number",
            showConversion: true,
            conversionValue: newValue,
          }}
          value={newValue}
          style={{ width: "100%" }}
        />
        <ContentFooter>
          <Button onClick={() => handleAdd(value)} style={{ width: "50%" }}>
            Ok
          </Button>
          <Button onClick={handleCancel} style={{ width: "50%" }}>
            Cancle
          </Button>
        </ContentFooter>
      </ContentDiv>
    );
  };

  return (
    <Accounts>
      <Row align={"center"} style={{ marginBottom: "1rem" }}>
        <ThemeTextLabel
          fontSize={"1.4rem"}
          title="Allow No. of Account Openings"
          color={token.colorTextBase}
          titleWrapperStyle={{
            marginBottom: rent ? "2rem" : "1rem",
          }}
        />
      </Row>
      <Row
        align={"left"}
        gutter={[20, 10]}
        style={{ alignItems: "center", margin: "1rem" }}
      >
        {accountOptions?.map((item, index) => {
          return (
            <React.Fragment key={item?.value}>
              {!rent && (
                <AccountOpeningViewCol xs={24} sm={12} md={6} lg={4} xl={4}>
                  <ThemeTextLabel required title={item?.label} />
                </AccountOpeningViewCol>
              )}
              <Col
                xs={24}
                sm={12}
                md={rent ? 10 : 6}
                lg={rent ? 10 : 8}
                xl={rent ? 8 : 8}
              >
                <ThemeInputNumber
                  extraProps={{
                    input_type: "number",
                    addonBefore: is_edits && (
                      <>
                        <Popover
                          title={item?.value2}
                          open={
                            showModal?.flage &&
                            showModal?.name ===
                              `allowNoOfAccount${item?.value2}` &&
                            showModal.action === "add"
                          }
                          onClick={() =>
                            showPopover(
                              `allowNoOfAccount${item?.value2}`,
                              "add"
                            )
                          }
                          content={() => content(item?.value2)}
                        >
                          <AddButton isAdd token={token}>
                            +
                          </AddButton>
                        </Popover>
                      </>
                    ),
                    addonAfter: is_edits && (
                      <Popover
                        title={item?.value2}
                        open={
                          showModal?.flage &&
                          showModal?.name ===
                            `allowNoOfAccount${item?.value2}` &&
                          showModal.action === "remove"
                        }
                        onClick={() =>
                          showPopover(
                            `allowNoOfAccount${item?.value2}`,
                            "remove"
                          )
                        }
                        content={() => content(item?.value2)}
                      >
                        <AddButton token={token}>-</AddButton>
                      </Popover>
                    ),
                  }}
                  required
                  title={rent ? item?.label : ""}
                  inputProps={{
                    placeholder: "0",
                    readOnly: is_edits,
                    name: `allowNoOfAccount${item?.value2}`,
                    step: 1,
                    suffix: is_edits
                      ? `/${converterFunction(
                          accountDetails?.historicalData?.[item?.value2]
                        )}`
                      : null,
                  }}
                  formProps={{
                    name: `allowNoOfAccount${item?.value2}`,
                    rules: [
                      () => ({
                        validator(_, value) {
                          if (
                            (is_edits &&
                              isMaster &&
                              value >= 0 &&
                              value !== "" &&
                              value !== null) ||
                            (is_edits &&
                              !isMaster &&
                              value <=
                                parentDetails[
                                  `allowNoOfAccount${item?.value2}`
                                ] +
                                  constantValue?.[
                                    `allowNoOfAccount${item?.value2}`
                                  ] &&
                              value !== "" &&
                              value !== null &&
                              value >= 0) ||
                            (isMaster &&
                              !is_edits &&
                              value >= 0 &&
                              value !== "" &&
                              value !== null) ||
                            (!is_edits &&
                              value !== "" &&
                              value !== null &&
                              value <=
                                parentDetails[
                                  `allowNoOfAccount${item?.value2}`
                                ])
                          ) {
                            return Promise.resolve();
                          } else {
                            if (isMaster) {
                              return Promise.reject(
                                `Please fill positive number of account opening of ${item?.value2} `
                              );
                            }
                            if (
                              parentDetails[
                                `allowNoOfAccount${item?.value2}`
                              ] === 0 &&
                              !is_edits
                            ) {
                              return Promise.reject(
                                `${parentBasicInfo.accountName}(${parentBasicInfo.userId}) don't have enough number of ${item?.value2} accounts, Please enter 0`
                              );
                            }
                            if (is_edits) {
                              return Promise.reject(
                                `You cannot allow a number of account openings for ${
                                  item?.value2
                                } less than 0 or more than  ${
                                  constantValue?.[
                                    `allowNoOfAccount${item?.value2}`
                                  ] +
                                  parentDetails[
                                    `allowNoOfAccount${item?.value2}`
                                  ]
                                } `
                              );
                            } else {
                              return Promise.reject(
                                `You cannot allow a number of account openings for ${
                                  item?.value2
                                } less than 0 or more than ${
                                  parentDetails[
                                    `allowNoOfAccount${item?.value2}`
                                  ]
                                }`
                              );
                            }
                          }
                        },
                      }),
                    ],
                  }}
                  marginBottom={"0px !important"}
                />
              </Col>
            </React.Fragment>
          );
        })}
      </Row>
    </Accounts>
  );
};

export default React.memo(AccountOpeningView);
